import React from "react";

const CogIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3387 6.85305L16.82 5.95298C16.3812 5.19138 15.4087 4.92864 14.6461 5.36564V5.36564C14.283 5.57949 13.8499 5.64017 13.4421 5.53428C13.0342 5.42839 12.6853 5.16464 12.4722 4.80118C12.3351 4.57017 12.2614 4.30704 12.2586 4.03841V4.03841C12.271 3.60773 12.1085 3.19038 11.8082 2.88143C11.5078 2.57249 11.0952 2.39826 10.6644 2.39844H9.61938C9.19727 2.39843 8.79256 2.56664 8.4948 2.86583C8.19704 3.16502 8.03078 3.57053 8.0328 3.99264V3.99264C8.02029 4.86415 7.3102 5.56405 6.4386 5.56396C6.16997 5.56117 5.90684 5.48749 5.67583 5.35038V5.35038C4.91318 4.91339 3.94072 5.17612 3.50191 5.93772L2.94509 6.85305C2.5068 7.6137 2.76596 8.58555 3.5248 9.02697V9.02697C4.01805 9.31174 4.32191 9.83803 4.32191 10.4076C4.32191 10.9771 4.01805 11.5034 3.5248 11.7882V11.7882C2.76693 12.2267 2.50749 13.1961 2.94509 13.9545V13.9545L3.4714 14.8622C3.677 15.2332 4.02197 15.507 4.42996 15.6229C4.83795 15.7389 5.27533 15.6875 5.64531 15.4801V15.4801C6.00903 15.2678 6.44245 15.2097 6.84925 15.3185C7.25604 15.4274 7.60249 15.6942 7.8116 16.0598C7.94871 16.2908 8.02239 16.5539 8.02518 16.8225V16.8225C8.02518 17.703 8.73893 18.4167 9.61938 18.4167H10.6644C11.5419 18.4168 12.2544 17.7076 12.2586 16.8302V16.8302C12.2565 16.4067 12.4239 16.0001 12.7233 15.7006C13.0227 15.4012 13.4294 15.2339 13.8528 15.236C14.1208 15.2431 14.3828 15.3165 14.6156 15.4495V15.4495C15.3762 15.8878 16.3481 15.6287 16.7895 14.8698V14.8698L17.3387 13.9545C17.5513 13.5896 17.6096 13.1551 17.5008 12.747C17.392 12.339 17.125 11.9912 16.759 11.7806V11.7806C16.3929 11.57 16.1259 11.2222 16.0171 10.8142C15.9083 10.4061 15.9667 9.97156 16.1793 9.60668C16.3175 9.36532 16.5176 9.16521 16.759 9.02697V9.02697C17.5133 8.58579 17.7718 7.61962 17.3387 6.86068V6.86068V6.85305Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10.1455"
        cy="10.4075"
        r="2.1968"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CogIcon;
